/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_DoorInputs */

const en_us2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log a finished workout`)
};

const pt_br2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar treino feito`)
};

const es_419_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar entrenamiento hecho`)
};

const pt_pt2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registar treino feito`)
};

const fr_fr2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noter une séance faite`)
};

const de_de2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigtes Training eintragen`)
};

const it_it2_workout_quick_door = /** @type {(inputs: Workout_Quick_DoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra un allenamento fatto`)
};

/**
* | output |
* | --- |
* | "Log a finished workout" |
*
* @param {Workout_Quick_DoorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_door = /** @type {((inputs?: Workout_Quick_DoorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_DoorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_door(inputs)
	if (locale === "es-419") return es_419_workout_quick_door(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_door(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_door(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_door(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_door(inputs)
	return en_us2_workout_quick_door(inputs)
});
export { workout_quick_door as "workout-quick.door" }